import {Node, PropertyOrKeyValue} from "../../Node";
import {PNumber} from "../../properties/PNumber";
import {PBoolean} from "../../properties/PBoolean";
import {PVector3} from "../../properties/PVector3";
import {v3} from "oc-threejs/short3";

export class CameraNode extends Node {

    near: number;
    far: number;
    fov: number;
    position: PVector3;
    target: PVector3;
    enableDamping: boolean;
    dampingFactor: number;
    // autoRenderDuration: number;
    screenSpacePanning: boolean;

    constructor() {
        super();
        this.near = this.camera.near;
        this.far = this.camera.far;
        this.fov = this.camera.fov;
        this.position = this.camera.position;
        this.target = this.controls.target;
        this.enableDamping = this.controls.enableDamping;
        this.dampingFactor = this.controls.dampingFactor;
        // this.autoRenderDuration = this.controls.autoRenderDuration;
        this.screenSpacePanning = this.controls.screenSpacePanning;
    }

    get camera() {
        return APP.camera;
    }

    get controls() {
        return APP.controls;
    }

    createProperties() {
        return [
            new PVector3({
                "name": "position",
                "default": [4,1.8,4],
                "comment": I18N("scene editor:camera position comment"),
                node: this
            }),
            new PVector3({
                "name": "target",
                "default": [0,0,0],
                "comment": I18N("scene editor:camera target comment"),
                node: this
            }),
            new PNumber({
                "name": "near",
                "default": 0.1,
                "min": 0.0001,
                "max": 1000000,
                "decimals": 2,
                "slider": false,
                "comment": I18N("scene editor:camera near comment"),
                node: this
            }),
            new PNumber({
                "name": "far",
                "default": 2000,
                "min": 0,
                "max": 1000000,
                "decimals": 0,
                "slider": false,
                "comment": I18N("scene editor:camera far comment"),
                node: this
            }),
            new PNumber({
                "name": "fov",
                "default": 50,
                "min": 0,
                "max": 360,
                "decimals": 0,
                "comment": I18N("scene editor:camera fov comment"),
                node: this
            }),
            {separator: true},
            new PBoolean({
                "name": "enableDamping",
                "default": true,
                "comment": I18N("scene editor:camera damping comment"),
                node: this
            }),
            new PNumber({
                "name": "dampingFactor",
                "default": 0.08,
                "min": 0.00001,
                "max": 1,
                "decimals": 3,
                "comment": I18N("scene editor:camera dampingfactor comment"),
                node: this
            }),
            // new PNumber({
            //     "name": "autoRenderDuration",
            //     "inputScale": 1000,
            //     "default": 1,
            //     "min": 0,
            //     "max": 60,
            //     "decimals": 0.1,
            //     "comment": "Wie lange werden nach einer Bewegung der Kamera automatisch weitere Frames gerendert? Wichtig für Damping-Animation, da muss der Wert zusammen mit dampingFactor ausprobiert werden und groß genug sein.",
            //     node: this
            // }),
            {separator: true},
            new PBoolean({
                "name": "screenSpacePanning",
                "default": false,
                "comment": I18N("scene editor:camera screenspacepanning comment"),
                node: this
            }),
        ] as PropertyOrKeyValue[];
    }

    init() {
        super.init();
        this.updateScene();
        return this;
    }

    updateScene() {
        this._dataChanged = {};
        if (this.changed('near') || this.changed('far') || this.changed('fov')) {
            this.camera.near = this.near;
            this.camera.far = this.far;
            this.camera.fov = this.fov;
            this.camera.updateProjectionMatrix();
        }
        if (this.changed('enableDamping') || this.changed('dampingFactor') || this.changed('autoRenderDuration') || this.changed('screenSpacePanning')) {
            this.controls.enableDamping = this.enableDamping;
            this.controls.dampingFactor = this.dampingFactor;
            // this.controls.autoRenderDuration = this.autoRenderDuration;
            this.controls.screenSpacePanning = this.screenSpacePanning;
        }
        if(this.changed('position')) {
            this.camera.position.copy(v3(this.position[0], this.position[1], this.position[2]));
        }
        if(this.changed('target')) {
            this.controls.target.copy(v3(this.target[0], this.target[1], this.target[2]))
        }
    }

    getName() {
        return "Camera";
    }

}
